import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Icon,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";

import { PaymentElement } from "@stripe/react-stripe-js";
import React from "react";
import { HiChevronRight } from "react-icons/hi2";
import { useSetupPaymentMethod } from "../hooks/useSetupPaymentMethod";

const SetupPaymentMethod: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}> = ({ isOpen, onClose, onSuccess }) => {
  const {
    handleStripePaymentMethodSubmit,
    stripePaymentMethodSubmitLoading,
    stripeErrorMessage,
  } = useSetupPaymentMethod({
    onClose: onSuccess,
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"lg"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Añadir un método de pago</ModalHeader>
        <ModalCloseButton />

        <VStack align={"flex-start"} w={"full"} spacing={6} px={6} py={4}>
          <VStack
            as={"form"}
            w={"full"}
            onSubmit={handleStripePaymentMethodSubmit}
          >
            <Box w={"full"}>
              <PaymentElement
                options={{
                  layout: "auto",
                  business: { name: "SALA" },
                  fields: {
                    billingDetails: "auto",
                  },
                }}
              />
            </Box>

            <Button
              size={"md"}
              mt={4}
              borderRadius={"2xl"}
              color={"white"}
              colorScheme={"secondary"}
              rightIcon={<Icon as={HiChevronRight} ml={10} />}
              justifyContent={"space-between"}
              alignSelf={"flex-end"}
              // isDisabled={!validAddress}
              isLoading={stripePaymentMethodSubmitLoading}
              type="submit"
            >
              Guardar
            </Button>
          </VStack>

          {stripeErrorMessage && (
            <Alert status="error">
              <AlertIcon />
              {stripeErrorMessage}
            </Alert>
          )}
        </VStack>
      </ModalContent>
    </Modal>
  );
};

export default SetupPaymentMethod;
